import React from "react";
import SeoForm from "./components/SeoForm";

function AddMainCategorySeo() {
  return <SeoForm entityType="main-category" />;
}

export default AddMainCategorySeo;
